module.exports = __webpack_public_path__ + "static/JetBrainsMono-Medium-54b6827550ef145b4c1968518a96070f.woff2";